import { trackEvent } from "src/utils/api/tracker";

export function onStartPaymentSurvey() {
  trackEvent("StartedPaymentSurvey");
  window.conversionTracker.trackViewContentWithParamsExsf0({
    content_type: "FBMG-StartedPaymentSurvey",
  });
}
